<template>
  <div class="body">
    <div class="title">
            <span class="search">
                <el-input class="searchInput" @change="search" v-model="page.condition.key"
                          placeholder="姓名/手机号"></el-input>
            </span>
      <!-- <span class="sortA">
          <el-select v-model="page.condition.datumStatus" placeholder="审核状态">
          <el-option v-for="item in statusType"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
          </el-select>
      </span> -->
      <span class="sortB">
                  <el-date-picker v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"
                                  start-placeholder="开始日期" end-placeholder="结束日期"
                                  @change="timeSection"></el-date-picker>
            </span>
      <!-- <span class="sortC">
          <el-select v-model="page.condition.source" placeholder="会员类型">
          <el-option v-for="item in vipTypeList"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
          </el-select>
      </span> -->
      <span class="sortD">
                <el-input class="inputDepart" v-model="page.condition.departmentKey" placeholder="部门名/编号"></el-input>
            </span>
      <span class="sortE">
                <el-button type="primary" @click="search">查询</el-button>
                <el-button plain @click="reset">重置</el-button>
            </span>
    </div>
    <div class="content">
      <p class="contentHead">
                <span>
                    <el-button type="primary" @click="addStaff">新增</el-button>
                </span>
      </p>
      <div class="table">
        <el-table :data="list" :header-cell-style="tableHeaderColor" v-loading="loading" style="width: 100%">
          <el-table-column width="50" label="">
            <template slot-scope="scope">
              <img class="imgHead" :src="scope.row.avatar"
                   @click="openMonify(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="sex" :formatter="sexType" width="80" label="性别"></el-table-column>
          <el-table-column prop="age" label="年龄" width="80"></el-table-column>
          <el-table-column prop="telNumber" width="120" label="电话"></el-table-column>
          <el-table-column prop="jobNumber" label="工号" width="100"></el-table-column>
          <el-table-column prop="departmentName" label="部门"></el-table-column>
          <el-table-column prop="idCard" label="证件号码"></el-table-column>
          <el-table-column prop="birthDt" label="出生日期"></el-table-column>
          <el-table-column prop="entryDt" label="录入时间"></el-table-column>
          <el-table-column prop="datumStatus" label="操作">
            <template slot-scope="scope">
              <div style="display:flex;width:auto;height:auto;align-items:center;">
                <img class="imgOpera" @click="updateStaff(scope.row.id)"
                     src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/xiugai.png">
                <img class="imgOpera" @click="deleteStaff(scope.row.id)"
                     src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/shanchu.png">
                <!-- <img class="imgOpera" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/authority.png"> -->
                <img class="imgOpera" @click="turnOver(scope.row)"
                     src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/icon_yijiao.png">

                <i class="iconfont iconfont-renew"
                   @click="transferClientStaff(scope.row)"
                >&#xe63d;</i>

                <i class="iconfont iconfont-power"
                   @click="operatEquip(scope.row)"
                >&#xe681;</i>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <span class="customNumber">成员人数:{{ total }}人</span>
        <span class="customPage"><el-pagination background layout="prev, pager, next" :current-page="page.current"
                                                @current-change="handleCurrentChange" :page-size="page.size"
                                                :total="total"></el-pagination></span>

      </div>


      <el-dialog title="请填写移交对象" :visible.sync="dialogVisible" width="20%">
        <el-input v-model="trunForm.newCode" placeholder="请填写移交对象工号"></el-input>
        <el-input class="inputText" type="textarea" v-model="trunForm.remark" :rows="2"
                  placeholder="备注信息(非必填)"></el-input>
        <span>
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sendTrun">确 定</el-button>
                    </span>
      </el-dialog>

      <!-- 员工更换部门-->
      <div class="shade" v-if="isShade">
        <div class="Staff-after">
          <div class="Staff-after-title">请选择转移部门</div>
          <el-cascader
            style="width:calc(100% - 4rem);margin:0.7rem 0"
            :options="departs"
            :props="{multiple: false, checkStrictly: true,value:'code',label:'name',children:'sub'}"
            :clearable="true"
            v-model="departsCode"
            :show-all-levels="false"
          ></el-cascader>
          <div class="Staff-after-btn">
            <div class="Staff-after-btn-single"
                 style="border:1px solid #DCDFE6"
                 @click="cancelAfter"
            >
              取消
            </div>
            <div class="Staff-after-btn-single"
                 style="background-color: #0e77ca;color:white"
                 @click="ensureAfter"
            >
              确定
            </div>
          </div>
        </div>
      </div>

      <!-- 重置修改用户密码 -->
      <div class="shade" v-if="isShadePassworld">
        <div class="Staff-after">
          <div class="Staff-after-title">修改员工密码</div>
          <el-input style="width:calc(100% - 4rem);margin:0.7rem 0"
                    v-model="newPassword"
                    minlength="8"
                    placeholder="请输入新密码"/>
          <div class="Staff-after-btn">
            <div class="Staff-after-btn-single"
                 style="border:1px solid #DCDFE6"
                 @click="cancelMonifyPassworld"
            >
              取消
            </div>
            <div class="Staff-after-btn-single"
                 style="background-color: red;color:white"
                 @click="resetPassworld"
            >
              重置
            </div>
            <div class="Staff-after-btn-single"
                 style="background-color: #0e77ca;color:white"
                 @click="ensurePassworld"
            >
              确定
            </div>
          </div>
        </div>
      </div>


      <!--      登录设备设置-->
      <div class="shade" v-if="isOperatEquip">
        <div class="Staff-after">
          <div class="Staff-after-title">登录设备管理</div>
          <div class="register-register-man">
            <el-radio v-model="radio" label="1" @change="isDevices = false">允许一个设备登录</el-radio>
          </div>
          <div class="register-register-man">
            <el-radio v-model="radio" label="2" @change="isDevices = true">允许多个设备登录</el-radio>
          </div>
          <input class="devices" v-if="isDevices"
                 v-model="devices"
                 placeholder="请输入登录设备数"/>
          <div class="register-register-man">
            <el-radio v-model="radio" label="3" @change="isDevices = false">允许无限个设备登录</el-radio>
          </div>
          <div class="Staff-after-btn">
            <div class="Staff-after-btn-single"
                 style="border:1px solid #DCDFE6"
                 @click="cancelDevices()"
            >
              取消
            </div>
            <div class="Staff-after-btn-single"
                 style="background-color: #0e77ca;color:white"
                 @click="confirmDevices()"
            >
              确定
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  data() {
    return {
      page: {
        condition: {
          key: null,
          startDt: null,
          endDt: null,
          departmentKey: null,
        },
        current: 1,
        size: 13,
        sorts: [
          {
            sortColumn: 'id',
            sortType: 'DESC',
          }
        ]
      },
      loading: true,
      list: [],
      total: null,
      time: '',
      statusType: null,
      vipTypeList: null,
      dialogVisible: false,
      trunForm: {
        id: null,
        newCode: null,
        remark: null,
      },
      isShade: false,
      isOperatEquip: false,
      departs: [],
      departsCode: '',
      client: {},
      isShadePassworld: false,
      newPassword: '',
      staff: {},
      radio: 0,
      isDevices: false,
      devices: '',
      devicesStaffId: ''
    }
  },
  mounted() {
    this.staffList()
    this.filtrate()
  },
  methods: {

    //编辑员工
    updateStaff(id) {
      this.$router.replace('/index/staffInfo?id=' + id)
    },
    //删除员工
    deleteStaff(id) {
      this.joker.staff.staffDelete(id).then(res => {
        console.log(res)
        alert('删除成功')
        this.staffList()
      })
    },
    //移交
    turnOver(row) {
      console.log(row)
      this.trunForm.id = row.id
      this.dialogVisible = true
    },
    //确定移交
    sendTrun() {
      this.joker.staff.staffTurnOver(this.trunForm).then(res => {
        const  success = value.success
        if(!success){
          const  msg = value.message
          Message.error(msg)
        }
      })
      this.dialogVisible = false
    },
    //新增员工
    addStaff() {
      this.$router.replace('/index/addStaff')
    },
    //筛选条件
    filtrate() {
      this.joker.customer.getVipTypeAndExceptionStatus().then(res => {
        this.statusType = res.content.exceptionStatus
        this.vipTypeList = res.content.vipType
      })
    },

    //分页
    staffList() {
      this.loading = true
      this.joker.staff.staffList(this.page).then(res => {
        this.list = res.content.records
        this.total = res.content.total
        this.loading = false
      })
    },

    //下一页
    handleCurrentChange(val) {
      console.log(val)
      this.page.current = val
      this.staffList();
    },
    //搜索
    search() {
      this.page.current = 1
      this.staffList();
    },

    //性别判断
    sexType(row, column) {
      if (row.sex == 1) {
        return '男'
      } else {
        return '女'
      }
    },


    // 修改table header的背景色
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return 'background-color: #ECEEF0;color: #606266'
      }
    },

    timeSection(e) {
      console.log(this.time[0])
      this.page.condition.startDt = this.time[0] + ' 00:00:00'
      this.page.condition.endDt = this.time[1] + ' 23:59:59'
      console.log(this.page)
    },
    //重置
    reset() {
      this.page.condition.key = null
      this.page.condition.startDt = null
      this.page.condition.endDt = null
      this.page.condition.departmentKey = null
      this.page.current = 1
      this.staffList();
    },
    //点击转移客户部门
    transferClientStaff(client) {
      this.isShade = true
      //获取部门信息
      this.joker.department.departList().then(res => {
        const departs = res.content
        if (departs && departs.length > 0) {
          this.departs = departs
          this.departsCode = client.departmentCode
          this.client = client
        }
      })
    },
    //点击取消更换
    cancelAfter() {
      this.isShade = false
    },
    //点击确定更换部门
    ensureAfter() {
      if (!(this.client.departmentCode == this.departsCode)) {
        let params = new URLSearchParams()
        params.set("staffCode", this.client.jobNumber)
        if (!this.departsCode) {
          Message.warning("请选择部门！")
          return
        }
        params.set("deptCode", this.departsCode.pop())
        //说明更换了部门，修改后端数据
        axios.post(`${ipAddress.qi}/admin/a1/staff/updateDpetCode`, params).then(
          value => {
            const success = value.success
            if (success) {
              this.isShade = false;
              this.staffList();
              Message.success("转移成功！")
            } else {
              const msg = value.message
              Message.error(msg)
            }
          }
        )
      }
    }
    ,
    //点击取消修改员工密码蒙层
    cancelMonifyPassworld() {
      this.isShadePassworld = false
    },
    //点击打开修改员工密码蒙层
    openMonify(Staff) {
      this.isShadePassworld = true
      this.staff = Staff
    },
    //点击重置员工密码
    resetPassworld() {
      let params = new URLSearchParams()
      params.set("staffId", this.staff.id)
      params.set("idCard", this.staff.idCard)
      axios.post(`${ipAddress.qi}/admin/a1/staff/reset/passworld`, params).then(value => {
        const success = value.success
        if (success) {
          this.isShadePassworld = false;
          this.staffList();
          Message.success("重置密码成功！")
        } else {
          const msg = value.message
          Message.error(msg)
        }
      })
    },
    //点击确定修改密码
    ensurePassworld() {
      if (this.newPassword && this.newPassword.length >= 8) {
        let params = new URLSearchParams()
        params.set("staffId", this.staff.id)
        params.set("password", this.newPassword)
        axios.post(`${ipAddress.qi}/admin/a1/staff/modify/passworld`, params).then(value => {
          const success = value.success
          if (success) {
            this.isShadePassworld = false;
            this.staffList();
            this.newPassword = '';
            Message.success("修改密码成功！")
          } else {
            const msg = value.message
            Message.error(msg)
          }
        })
      } else {
        Message.warning("请输入正确的密码格式！")
      }
    },
    //点击操作设备
    operatEquip(staff) {
      this.isOperatEquip = true;
      const devices = staff.devices
      if (devices == null || devices == -1) {
        this.radio = '3'
        this.isDevices = false
      } else if (devices == 1) {
        this.radio = '1'
        this.isDevices = false
      } else {
        this.radio = '2'
        this.devices = devices
        this.isDevices = true
      }
      this.devicesStaffId = staff.id
    },
    //点击取消设备设置
    cancelDevices() {
      this.devices = ''
      this.radio = 0
      this.devicesStaffId = ''
      this.isOperatEquip = false
    },
    //点击确认设备设置
    confirmDevices() {
      let devices;
      switch (this.radio) {
        case '1':
          devices = 1
              break
        case '2':
          devices = this.devices
              break
        case '3':
          devices = -1
              break
        default:
      }
      if (!devices) {
        Message.warning("请输入设备个数！")
        return
      }

      let params = new URLSearchParams()
      params.set("staffId", this.devicesStaffId)
      params.set("devices", devices)
      axios.post(`${ipAddress.qi}/admin/a1/staff/devices`, params).then(
        value => {
          const success = value.success
          if (!success) {
            const msg = value.message
            Message.error(msg)
          } else {
            Message.success("修改成功")
            this.staffList();
          }
          this.cancelDevices()
        }
      )
    }
  }
}
</script>

<style scoped>
.body {
  position: relative;
  padding: 10px;
}

.shade {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.Staff-after {
  height: auto;
  width: auto;
  z-index: 10;
  background-color: white;
  border-radius: 5px;
}

.Staff-after-title {
  letter-spacing: 2px;
  font-size: 0.95rem;
  width: 20rem;
  height: auto;
  position: relative;
  padding: 0.7rem 0;
}

.Staff-after-btn {
  width: calc(100% - 4rem);
  margin: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 0;
}

.Staff-after-btn-single {
  font-size: 0.95rem;
  letter-spacing: 2px;
  border-radius: 5px;
  background-color: white;
  padding: 0.6rem 1.4rem;
}

.title {
  background-color: #FFFF;
  width: 98%;
  line-height: 60px;
  margin-bottom: 0.5%;
  border-radius: 10px;
}

.search {
  display: inline-block;
  width: 58%;
  /* top: 20%; */
  /* width:700px; */
  /* background-color: #5790DF; */

}

.searchInput {
  width: 50%;
  margin-left: 1%
}

.sortA {
  display: inline-block;
  width: 7%;
}

.sortB {
  display: inline-block;
  width: 21%;
}

.sortC {
  display: inline-block;
  width: 7%;
}

.content {
  border-radius: 10px;
  width: 98%;
  background-color: #FFFFFF;
  margin-left: 1%;
}

.table {
  width: 98%;
  margin-left: 1%;
  padding-bottom: 1%;
  padding-top: 1%
}

.contentState {
  text-align: left;
  background-color: #FFFF;
  padding-top: 1%;
  padding-left: 0.5%;
  font-size: 18px;
  border-radius: 10px;
}

.stateA {
  color: #5790DF;
}

.stateB {
  margin-left: 2%
}

.customNumber {
  display: inline-block;
  width: 25%;
  text-align: left;
  line-height: 60px;
  font-size: 18px;
  font-weight: 600;
  /* background-color: aqua; */
}

.customPage {
  display: inline-block;
  width: 70%;
  line-height: 40px;
  text-align: right;
  /* background-color: beige; */
  vertical-align: middle;
  padding-top: 10px;
}

.inputDepart {
  width: 10%;
}

.contentHead {
  padding-top: 1%;
  width: 98%;
  margin-left: 1%;
  text-align: left;
}

.imgHead {
  width: 35px;
  height: 35px;
  border-radius: 100%;
}

.imgOpera {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}

.iconfont-renew {
  margin-left: 7px;
  font-size: 1.3rem;
  color: rgb(242, 153, 37);
}

.iconfont-power {
  margin-left: 7px;
  font-size: 1.6rem;
  color: #365EFF;
}

.inputText {
  margin-top: 2%;
  margin-bottom: 5%;
}

.register-register-man {
  width: 100%;
  height: auto;
  padding: 0.7rem 0 0.7rem 4rem;
  display: flex;
  justify-content: flex-start;
}

.devices {
  font-size: 0.9rem;
  letter-spacing: 1px;
  outline: none;
  border: 1px solid #707070;
  text-indent: 4px;
  width: 9rem;
}

.devices::-webkit-input-placeholder {
  color: #676767;
}
</style>



// WEBPACK FOOTER //
// src/components/Staff/staffList.vue